import { useMediaQuery } from '@mui/material'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import Stack from '@mui/material/Stack'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import Typography from '@mui/material/Typography'
import { FC, SyntheticEvent, useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import AppleStore from '../../assets/icons/AppleStore.svg'
import PlayStore from '../../assets/icons/PlayStore.svg'
import Send from '../../assets/icons/Send.svg'
import appImage from '../../assets/images/app.png'
import telegramBotImage from '../../assets/images/telegram-bot.png'
import GoogleImage from '../../assets/images/google.svg'
import AppStoreImage from '../../assets/images/app-store.svg'
import { ModalDialogWrapper } from '../../components/ModalDialogWrapper'
import { TELEGRAM_BOT_URL } from '../../constants/links.constants'
import { useUserStore } from '../../store/storeUser'
import { theme } from '../../theme'

type Props = {
    open: boolean
    handleClose: VoidFunction
}

export const TelegramBotDialog: FC<Props> = ({ open, handleClose, hideCheckbox }) => {
    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const [searchParams] = useSearchParams()
    const { userPersonalData, updateUserPersonalData } = useUserStore()
    const [value, setValue] = useState(+searchParams.get('tab'))
    const [isCheck, setIsCheck] = useState(false)

    const handleChange = (event: SyntheticEvent, newValue: number) => {
        setValue(newValue)
    }
    useEffect(() => {
        if (isCheck) {
            updateUserPersonalData({ banners: { main_telegram: true } })
            handleClose()
        }
    }, [isCheck])

    useEffect(() => {
        setValue(+searchParams.get('tab'))
    }, [searchParams])

    const handleClickOpenApp = () => {
        window.open(
            'https://redirect.appmetrica.yandex.com/serve/317784368238116898',
            '_blank',
            'noopener',
        )

        handleClose()
    }

    const handleClickOpen = () => {
        window.open(TELEGRAM_BOT_URL, '_blank', 'noopener')

        handleClose()
    }

    return (
        <>
            <ModalDialogWrapper
                sx={{
                    '.MuiPaper-root': {
                        width: '472px',
                        maxWidth: '472px',
                        height: 'auto',
                    },
                }}
                footerActions={
                    userPersonalData?.banners?.main_telegram || hideCheckbox ? (
                        ''
                    ) : (
                        <Stack direction="row" gap={1} width="100%" sx={{ alignItems: 'center' }}>
                            <Checkbox
                                checked={isCheck}
                                onClick={() => setIsCheck(true)}
                                sx={{ width: '20px', height: '20px' }}
                            />
                            <Typography variant="caption2">Больше не показывать</Typography>
                        </Stack>
                    )
                }
                open={open}
                handleClose={handleClose}
                title={
                    <Stack
                        direction="row"
                        sx={{
                            width: '100%',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}>
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            sx={{
                                color: '#5A5F72',
                                borderBottom: 'none',
                                p: 0,
                                minHeight: '40px',
                                backgroundColor: '#fff',
                                '& .MuiButtonBase-root.Mui-selected': {
                                    borderBottom: '2px solid #006CFD',
                                    borderRadius: '0px',
                                    background: '#fff',
                                    color: '#181B25',
                                },
                                '& .MuiTab-root': {
                                    background: '#fff',
                                },
                            }}>
                            <Tab label="Приложение" />
                            <Tab label="Telegram" />
                        </Tabs>
                    </Stack>
                }>
                {value === 1 && (
                    <Stack sx={{ textAlign: 'left' }} gap={3} direction="row">
                        <Stack>
                            <Typography variant="body1" mb={isMobile ? 2 : 0}>
                                {isMobile
                                    ? 'Используйте бота для быстрых ответов и следите за новостями проекта'
                                    : 'Сканируйте QR-код, чтобы открыть бота'}
                            </Typography>
                            <Stack sx={{ marginTop: 'auto' }}>
                                <Button
                                    startIcon={<Send />}
                                    fullWidth={true}
                                    onClick={handleClickOpen}
                                    color="primary"
                                    variant="outlined"
                                    sx={{
                                        mb: '12px',
                                        padding: '8px 16px',
                                        fontSize: '14px',
                                        fontWeight: 400,
                                        lineHeight: '20px',
                                    }}>
                                    Открыть бота
                                </Button>
                                {/*<Button*/}
                                {/*    startIcon={<Megaphone />}*/}
                                {/*    fullWidth={true}*/}
                                {/*    // onClick={() => navigate(FINANCES_ROUTE)}*/}
                                {/*    color="primary"*/}
                                {/*    variant="outlined"*/}
                                {/*    sx={{*/}
                                {/*        padding: '8px 16px',*/}
                                {/*        fontSize: '14px',*/}
                                {/*        fontWeight: 400,*/}
                                {/*        lineHeight: '20px',*/}
                                {/*    }}>*/}
                                {/*    Новостной канал*/}
                                {/*</Button>*/}
                            </Stack>
                        </Stack>
                        {!isMobile && (
                            <img
                                loading="lazy"
                                src={telegramBotImage}
                                style={{ maxWidth: '165px', margin: '0 auto', display: 'flex' }}
                                alt="telegram bot"
                            />
                        )}
                    </Stack>
                )}
                {value === 0 && (
                    <Stack sx={{ textAlign: 'left' }} gap={3} direction="row">
                        <Stack>
                            <Typography variant="body1" mb={isMobile ? 2 : 0}>
                                {isMobile ? 'Установите приложение, чтобы получить быстрый доступ к ассистентам' : '  Сканируйте QR-код для загрузки приложения'}

                            </Typography>
                            <Stack sx={{ marginTop: 'auto' }}>
                                <Button
                                    startIcon={<PlayStore />}
                                    fullWidth={true}
                                    onClick={handleClickOpenApp}
                                    color="primary"
                                    variant="outlined"
                                    sx={{
                                        borderRadius: '6px',
                                        border: '1px solid #E7E8EE',
                                        background: '#F5F5F5',
                                        mb: '12px',
                                        padding: '6.5px 126px 6.5px 8px',
                                        fontSize: '14px',
                                        fontWeight: 400,
                                        lineHeight: '20px',
                                        justifyContent: 'flex-start'
                                    }}>
                                    <GoogleImage />

                                </Button>
                                {/* <Button
                                    startIcon={<AppleStore />}
                                    fullWidth={true}
                                    onClick={handleClickOpenApp}
                                    color="primary"
                                    variant="outlined"
                                    sx={{
                                        borderRadius: '6px',
                                        border: '1px solid #E7E8EE',
                                        background: '#F5F5F5',
                                        padding: '6.5px 126px 6.5px 8px',
                                        fontSize: '14px',
                                        fontWeight: 400,
                                        lineHeight: '20px',
                                        justifyContent: 'flex-start'
                                    }}>
                                    <AppStoreImage />

                                </Button> */}
                            </Stack>
                        </Stack>
                        {!isMobile && (
                            <img
                                loading="lazy"
                                src={appImage}
                                style={{ maxWidth: '165px', margin: '0 auto', display: 'flex' }}
                                alt="telegram bot"
                            />
                        )}
                    </Stack>
                )}
            </ModalDialogWrapper>
        </>
    )
}
